// React
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

// API
import { useConfigTableColumns } from "../../api/config-table-columns/ConfigTableColumnsAPI";

// Component
import TableMenuOptions from "../table/TableMenuOptions";
import Modal from "../modal/Modal";
import TableComponent from "./TableComponent";

// Translate
import { tranStr } from "../../utils/translation";

// Functions
import isEmpty from "../../validation/is-empty";

Table.propTypes = {
  moduleId: PropTypes.string,
  tableName: PropTypes.string,
  columns: PropTypes.array,
  maxNoColumnsAllowed: PropTypes.number,
};

export default function Table(props) {
  // Menu Props
  const { moduleId, tableName } = props;
  const { columns } = props;
  const { maxNoColumnsAllowed } = props;

  // Open / Close Menu
  const [configTableColumnsModal, setConfigTableColumnsModal] = useState(false);

  // Config
  const { configTableColumns } = useConfigTableColumns(moduleId, tableName);

  // Selected Columns
  const [selectedColumns, setSelectedColumns] = useState([]);

  useEffect(() => {
    const savedColumns = configTableColumns.data.columns;
    if (!isEmpty(savedColumns)) {
      // Set the already existing columns from the server
      setSelectedColumns(savedColumns);
    } else {
      // Set the default columns to active but take into consideration the max number of columns
      const defaultColumns = [];
      columns.forEach((c) => {
        if (
          maxNoColumnsAllowed &&
          defaultColumns.length < maxNoColumnsAllowed
        ) {
          defaultColumns.push({ label: c.heading, value: c.key });
        }
        // If no max number of columns are specified, just push all the default columns
        if (isEmpty(maxNoColumnsAllowed)) {
          defaultColumns.push({ label: c.heading, value: c.key });
        }
      });
      setSelectedColumns(defaultColumns);
    }
  }, [maxNoColumnsAllowed, columns, configTableColumns.data.columns]);

  // Final Display Columns
  const [displayColumns, setDisplayColumns] = useState([]);

  // Filter the columns based on the selected columns
  useEffect(() => {
    const enabledColumns = [];

    columns.forEach((c) => {
      if (selectedColumns.some((d) => d.value === c.key)) {
        enabledColumns.push(c);
      }
    });
    setDisplayColumns(enabledColumns);
  }, [selectedColumns, columns]);

  return (
    <div>
      <TableComponent
        {...props}
        columns={displayColumns}
        setConfigTableColumnsModal={setConfigTableColumnsModal}
      />
      <Modal
        // Modal Props
        title={tranStr(tableName) + " Column Options"}
        Component={TableMenuOptions}
        modal={configTableColumnsModal}
        setModal={setConfigTableColumnsModal}
        // Component Props
        selectedColumns={selectedColumns}
        setSelectedColumns={setSelectedColumns}
        columnKeys={columns.map((x) => {
          return { label: x.heading, value: x.key };
        })}
        maxNoColumnsAllowed={maxNoColumnsAllowed}
        // Props for API
        configTableColumns={configTableColumns}
        moduleId={moduleId}
        tableName={tableName}
      />
    </div>
  );
}
